// src/app/shared/pipes/sortable.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { SortConfig } from '../view-models/sort-config';
export type SortValueAccessor<T> = (item: T, column: string) => any;

@Pipe({
	name: 'sortable',
	pure: true
})
export class SortablePipe implements PipeTransform {
	constructor() {}

	transform<T>(items: T[] | null, config: SortConfig, valueAccessor: SortValueAccessor<T>): T[] {
		if (!items) return [];
		return this.sort(items, config, valueAccessor);
	}

	sort<T>(items: T[], config: SortConfig, valueAccessor: SortValueAccessor<T>): T[] {
		if (!items || !config.column) return items;

		return [...items].sort((a, b) => {
			const valueA = this.getNormalizedValue(valueAccessor(a, config.column));
			const valueB = this.getNormalizedValue(valueAccessor(b, config.column));

			if (valueA === null || valueA === undefined) return 1;
			if (valueB === null || valueB === undefined) return -1;

			const compareResult = this.compare(valueA, valueB);
			return config.direction === 'asc' ? compareResult : -compareResult;
		});
	}

	private getNormalizedValue(value: any): any {
		if (typeof value === 'string') {
			return value.toLowerCase();
		}
		return value;
	}

	private compare(a: any, b: any): number {
		if (a < b) return -1;
		if (a > b) return 1;
		return 0;
	}
}
